import { createAction, props } from '@ngrx/store';

import { ErrorResponse } from '#types/core';
import { MultipleListOfValuesResponse } from '#types/list';

//
// system / request lists
//

export const RequestLists = createAction('[System] - Request Lists');

//
// system lists
//

export const RequestSystemLists = createAction('[System.Lists] - Request System Lists');
export const RequestSystemListsSuccess = createAction(
  '[System.Lists] - Request System Lists Success',
  props<{ lists: MultipleListOfValuesResponse }>()
);
export const RequestSystemListsFailure = createAction('[System.Lists] - Request System Lists Failure', props<{ error: ErrorResponse }>());
